import { Links } from './links';

export class Language {

  constructor(
    public id: string,
    public flag_id: string,
    public name: string = null,
    public translations: {[index:string]: string} = null,
    public _links: Links = null) {
      //
    }
}



// WEBPACK FOOTER //
// ./src/app/Models/language.ts